const CONST = {
    'SET_CONFIG':'REPORT/SET_CONFIG',
    'SET_CONFIG_PREVIEW':'REPORT/SET_CONFIG_PREVIEW',
    'SET_SELECTED_ITEM':'REPORT/SET_SELECTED_ITEM',
    'FETCH_ITEM_SUCCESS':'REPORT/FETCH_ITEM_SUCCESS',
    'FETCH_ITEM_FAILED':'REPORT/FETCH_ITEM_FAILED',
    'FETCH_ITEMS_SUCCESS':'REPORT/FETCH_ITEMS_SUCCESS',
    'FETCH_ITEMS_FAILED':'REPORT/FETCH_ITEMS_FAILED',
    'ADD_ITEM_SUCCESS':'REPORT/ADD_ITEM_SUCCESS',
    'ADD_ITEM_FAILED':'REPORT/ADD_ITEM_FAILED',
    'UPDATE_ITEM_SUCCESS':'REPORT/UPDATE_ITEM_SUCCESS',
    'UPDATE_ITEM_FAILED':'REPORT/UPDATE_ITEM_FAILED',
    'DELETE_ITEM_SUCCESS':'REPORT/DELETE_ITEM_SUCCESS',
    'DELETE_ITEM_FAILED':'REPORT/DELETE_ITEM_SUCCESS',
    'FETCH_ITEM_PREVIEW_SUCCESS':'REPORT/FETCH_ITEM_PREVIEW_SUCCESS',
    'FETCH_ITEM_PREVIEW_FAILED':'REPORT/FETCH_ITEM_PREVIEW_FAILED',
}

export default CONST;